module.exports = __webpack_public_path__ + "static/media/wissenswertes_g.55843f78.jpg";